// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";

var defaultContext = {
  expanded: false,
  disabled: false
};

function initValue_1(param) {
  
}

var initValue = [
  defaultContext,
  initValue_1
];

function reducer(state, action) {
  return {
          expanded: !state.expanded,
          disabled: state.disabled
        };
}

var context = React.createContext(initValue);

function Accordion__Provider(props) {
  var disabled = props.disabled;
  var expanded = props.expanded;
  var onChange = props.onChange;
  var expanded$1 = expanded !== undefined ? expanded : false;
  var disabled$1 = disabled !== undefined ? disabled : false;
  var initialState = {
    expanded: expanded$1,
    disabled: disabled$1
  };
  var provider = context.Provider;
  var match = React.useReducer(reducer, initialState);
  var state = match[0];
  var value_1 = match[1];
  var value = [
    state,
    value_1
  ];
  React.useEffect((function () {
          Curry._1(onChange, state);
        }), [state]);
  return React.createElement(provider, {
              value: value,
              children: props.children
            });
}

var make = Accordion__Provider;

export {
  defaultContext ,
  initValue ,
  reducer ,
  context ,
  make ,
}
/* context Not a pure module */
